import { TUserInfoData } from "../api/branch/user";
import { TNullable } from "../config/types";

import { notificationNoPermission } from "./notifications";

export const hasRiskPermission = (userInfo: TNullable<TUserInfoData>): boolean => {
  const hasPermission = userInfo?.permissions?.configuring_risk_settings;

  if (!hasPermission) {
    notificationNoPermission();
  }

  return !!hasPermission;
};